export enum DV_PATHS {
  // Self mode
  ROOT = 'data-vault',
  PQ_INDEX = 'data-vault/pq',
  PQ_FULL_INTERVIEW = 'data-vault/pq/answer',
  PQ_SECTION = 'data-vault/pq/sections/:sectionId',
  PQ_SECTION_REINTERVIEW = 'data-vault/pq/sections/:sectionId/answer',

  // On-behalf-of mode (proxy actor — HOH or helper — acting on a household member)
  MEMBER_ROOT = 'data-vault/members/:memberId',
  MEMBER_PQ_INDEX = 'data-vault/members/:memberId/pq',
  MEMBER_PQ_FULL_INTERVIEW = 'data-vault/members/:memberId/pq/answer',
  MEMBER_PQ_SECTION = 'data-vault/members/:memberId/pq/sections/:sectionId',
  MEMBER_PQ_SECTION_REINTERVIEW = 'data-vault/members/:memberId/pq/sections/:sectionId/answer',

  HISTORY = 'data-vault/history',
  HISTORY_CERT_DETAIL = 'data-vault/history/certifications/:certificationId',
  HISTORY_CERT_SECTION_DETAIL = 'data-vault/history/certifications/:certificationId/sections/:sectionId',
  MEMBER_HISTORY = 'data-vault/members/:memberId/history',
  MEMBER_HISTORY_CERT_DETAIL = 'data-vault/members/:memberId/history/certifications/:certificationId',
  MEMBER_HISTORY_CERT_SECTION_DETAIL = 'data-vault/members/:memberId/history/certifications/:certificationId/sections/:sectionId',
  UPLOADED_FILES = 'data-vault/uploaded-files',
}
